<template>
  <div class="detNmae">
    <el-form
       class="fromData"
      label-position="right"
      label-width="120px"
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
    >
      <el-form-item label=" 设备标题" prop="name" style="widht:50%">
        <el-input v-model="ruleForm.name"></el-input>
      </el-form-item>
       <el-form-item label="设备型号" prop="name" style="widht:50%">
        <el-input v-model="ruleForm.name"></el-input>
      </el-form-item>
       <el-form-item label="观测要素" prop="name" style="widht:50%">
        <el-input v-model="ruleForm.name"></el-input>
      </el-form-item>
       <el-form-item label="观测要素个数" prop="name" style="widht:50%">
        <el-input v-model="ruleForm.name"></el-input>
      </el-form-item>
       <el-form-item label="要素上下限" prop="name" style="widht:50%">
        <el-input v-model="ruleForm.name"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible">取 消</el-button>
      <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
    </span>
  </div>
</template>
<script>
export default {
    props:{
        dirhidel:{
            type:Function,
            default:Function
        }
    },
  data() {
    return {
      ruleForm: {
        name: ""
      },
      rules: {
        name: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" }
        ]
      }
    };
  },
  methods:{
      submitForm(value){
        
        this.$refs[value].validate((valid) => {
          if (valid) {
            alert('submit!');
              this.dirhidel()
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      //取消
      dialogVisible(){
          this.dirhidel()
      },
  }
};
</script>
<style  scoped>
.detNmae{
    width: 100%;
}
.fromData {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
</style>